import groq from 'groq'

export default groq`{
  quote,
  attribution,
}`
